export const enFR = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  name: "Do you have any other questions?",
  description:
    "Our customer service is available Monday to Friday from 8am to 10pm and Saturday from 9am to 6pm. Contact us for any questions regarding your insurance.",
  mainEntity: {
    "@type": "Organization",
    name: "Lassie AB",
    url: "https://lassie.fr",
    logo: "https://lassie.fr/images/logo-with-name.svg",
    address: {
      "@type": "PostalAddress",
      streetAddress: "9 rue des Colonnes",
      addressLocality: "Paris",
      postalCode: "75002",
      addressCountry: "FR",
    },
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "customer support",
        email: "contact@lassie.fr",
        availableLanguage: ["English", "French"],
        areaServed: "FR",
        hoursAvailable: [
          {
            "@type": "OpeningHoursSpecification",
            closes: "22:00:00",
            dayOfWeek: "https://schema.org/Monday",
            opens: "08:00:00",
          },
          {
            "@type": "OpeningHoursSpecification",
            closes: "22:00:00",
            dayOfWeek: "https://schema.org/Tuesday",
            opens: "08:00:00",
          },
          {
            "@type": "OpeningHoursSpecification",
            closes: "22:00:00",
            dayOfWeek: "https://schema.org/Wednesday",
            opens: "08:00:00",
          },
          {
            "@type": "OpeningHoursSpecification",
            closes: "22:00:00",
            dayOfWeek: "https://schema.org/Thursday",
            opens: "08:00:00",
          },
          {
            "@type": "OpeningHoursSpecification",
            closes: "22:00:00",
            dayOfWeek: "https://schema.org/Friday",
            opens: "08:00:00",
          },
          {
            "@type": "OpeningHoursSpecification",
            closes: "18:00:00",
            dayOfWeek: "https://schema.org/Saturday",
            opens: "09:00:00",
          },
        ],
      },
      {
        "@type": "ContactPoint",
        contactType: "customer support",
        email: "sinistres@lassie.fr",
        availableLanguage: ["English", "French"],
        areaServed: "FR",
      },
      {
        "@type": "ContactPoint",
        contactType: "complaints",
        email: "reclamations@lassie.fr",
        availableLanguage: ["English", "French"],
        areaServed: "FR",
      },
      {
        "@type": "ContactPoint",
        contactType: "complaints",
        email: "reclamationssinistres@lassie.fr",
        availableLanguage: ["English", "French"],
        areaServed: "FR",
      },
    ],
  },
};
